import "./PageSizeSelector.css";

interface PageSizeSelectorProps {
  pageSize: number;
  onPageSizeChange: (size: number) => void;
}

const PageSizeSelector = ({ pageSize, onPageSizeChange }: PageSizeSelectorProps) => {
  const pageSizeOptions: number[] = [5, 7, 10, 20, 50, 100];

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    const newSize = parseInt(event.target.value, 10);
    onPageSizeChange(newSize);
  };

  return (
    <div className="page-size-selector">
      <label htmlFor="page-size-select" className="page-size-label">
        Show:
      </label>
      <select
        id="page-size-select"
        value={pageSize}
        onChange={handleChange}
        className="page-size-dropdown"
      >
        {pageSizeOptions.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span className="page-size-text">per page</span>
    </div>
  );
};

export default PageSizeSelector;
